import { render } from "./vector.vue?vue&type=template&id=952e2e2c"
import script from "./vector.vue?vue&type=script&lang=js"
export * from "./vector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__